import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=2c86320d&scoped=true&"
import script from "./Show.vue?vue&type=script&lang=js&"
export * from "./Show.vue?vue&type=script&lang=js&"
import style0 from "./Show.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Show.vue?vue&type=style&index=1&id=2c86320d&scoped=true&lang=css&"
import style2 from "./Show.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c86320d",
  null
  
)

export default component.exports